import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=361e07d7&"
import script from "./NewsFilter.vue?vue&type=script&lang=js&"
export * from "./NewsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('361e07d7', component.options)
    } else {
      api.reload('361e07d7', component.options)
    }
    module.hot.accept("./NewsFilter.vue?vue&type=template&id=361e07d7&", function () {
      api.rerender('361e07d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-filter/NewsFilter.vue"
export default component.exports